// DEPRECATED: This reducer/action/function is not used anymore. Pleasre remove and test.

import { SET_RECIPIENT_DETAILS } from '../reducers/recipientDetails';


export const setRecipientDetails = (data, category) => (dispatch) => {
  dispatch({
    type: SET_RECIPIENT_DETAILS,
    data,
    category,
  });
};



// WEBPACK FOOTER //
// ./src/actions/recipientDetails.js